import { useAsync } from 'react-async-hook'
import axios from 'axios'
import { Asset } from '@helium/spl-utils'

const heliusMetadataUrl = process.env.NEXT_PUBLIC_HELIUS_METADATA_URL

const useNFTMetadata = (mint: string): Asset => {
  const fetchMetadata = async () => {
    const retryDelay = 2000 // Delay in milliseconds before retrying
    const maxRetries = 3 // Maximum number of retries
    let attempt = 0

    while (attempt < maxRetries) {
      try {
        const cache = await fetch(`/api/cache?cacheId=${mint}-v3`)
        const data = await cache.json()
        if (data?.content) {
          return data
        }

        const response = await fetch(
          process.env.NEXT_PUBLIC_REACT_APP_SOLANA_RPC_HOST,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              jsonrpc: '2.0',
              id: 'text',
              method: 'getAsset',
              params: {
                id: mint,
              },
            }),
          },
        )
        const res = await response.json()

        if (res?.result) {
          // Cache the asset
          await fetch(`/api/cache`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              cacheId: `${mint}-v3`,
              data: res.result,
            }),
          })
          return res.result
        }

        throw new Error('Failed to fetch metadata')
      } catch (e) {
        const error = e as { response: { status: number } }
        if (error.response && error.response.status === 429) {
          attempt++
          if (attempt < maxRetries) {
            await new Promise((resolve) => setTimeout(resolve, retryDelay))
          } else {
            console.error('[test] error nft: Max retries reached', error)
            return undefined
          }
        } else {
          console.error('[test] error nft: ', error)
          return undefined
        }
      }
    }
  }

  const { result } = useAsync(fetchMetadata, [mint])

  return (
    result || {
      content: {
        metadata: {
          name: undefined,
          attributes: undefined,
        },
        json_uri: undefined,
        links: { image: undefined },
      },
    }
  )
}

export default useNFTMetadata
